import { gql } from "@apollo/client";

export const CONFIG_FIELDS = gql`
  fragment ConfigFields on MerchantConfig {
    id
    merchantId
    merchantIdentifier
    country
    currency
    features
    taxRates
    taxRate
    taxInclusivePrices
    serviceChargeRate
    serviceChargePlatforms
    isAutoPrintEnabled
    autoPrintLeadTime
    adyenMerchantId
    permissions
    customReportUrl
    customNavigations {
      label
      iconName
      permissions
      slug
      position
      customNavigationLinks {
        label
        iconName
        url
        authenticatedRetoolLink
        permissions
        slug
        position
      }
    }
  }
`;

export const GET_CONFIG_QUERY = gql`
  query GetConfig {
    config {
      ...ConfigFields
    }
    brands {
      id
      label
      archivedAt
      type
    }
    outlets {
      id
      label
      archived
    }
    paymentTypes {
      id
      label
    }
  }
  ${CONFIG_FIELDS}
`;
